(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["autoplay-video"] && !Shopify.designMode) return;
  try {
    (function () {
    function pickSrc(v) {
      var mobile = v.dataset.mobile;
      if (mobile && window.matchMedia('(max-width: 749px)').matches) return mobile;
      return v.dataset.desktop;
    }

    function playSafe(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function initVideo(v) {
      if (v.dataset.apvInit) return;
      v.dataset.apvInit = '1';
      if (!v.getAttribute('src')) v.src = pickSrc(v);

      if (!('IntersectionObserver' in window)) {
        playSafe(v);
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) playSafe(entry.target);
            else if (!entry.target.paused) entry.target.pause();
          });
        },
        { threshold: 0.25 }
      );
      io.observe(v);
    }

    function initButton(btn) {
      if (btn.dataset.apvInit) return;
      btn.dataset.apvInit = '1';
      btn.addEventListener('click', function () {
        var apv = btn.closest('.apv');
        var v = apv && apv.querySelector('.apv__video');
        if (!v) return;
        v.muted = !v.muted;
        btn.classList.toggle('apv__sound--on', !v.muted);
        btn.setAttribute('aria-label', v.muted ? 'Tap for sound' : 'Mute');
        if (!v.muted) playSafe(v);
      });
    }

    function init() {
      document.querySelectorAll('.apv__video').forEach(initVideo);
      document.querySelectorAll('.apv__sound').forEach(initButton);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
